import React from 'react';
import { Button, TextField, FormGroup, FormControlLabel, Checkbox, Grid, Typography, Paper, Divider } from '@mui/material';

const EditRoleForm = ({ roleTitle, setRoleTitle, rolePermissions, setRolePermissions, onSubmit }) => {
    return (
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: 'primary.main' }}>
                Edit Role
            </Typography>
            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        label="Role Title"
                        variant="outlined"
                        fullWidth
                        value={roleTitle}
                        onChange={(e) => setRoleTitle(e.target.value)}
                        sx={{ mb: 3 }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 'medium', color: 'text.secondary' }}>
                        Permissions
                    </Typography>
                    <FormGroup sx={{ ml: 2 }}>
                        {Object.entries(rolePermissions).map(([key, value]) => (
                            <FormControlLabel
                                key={key}
                                control={
                                    <Checkbox
                                        checked={!!value}
                                        onChange={(e) => setRolePermissions({ ...rolePermissions, [key]: e.target.checked })}
                                        sx={{ '&.Mui-checked': { color: 'primary.main' } }}
                                    />
                                }
                                label={key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase())}
                                sx={{ mb: 1, color: 'text.primary' }}
                            />
                        ))}
                    </FormGroup>
                </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Grid container justifyContent="flex-end">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => onSubmit({ title: roleTitle, permissions: rolePermissions })}
                    sx={{
                        fontWeight: 'bold',
                        textTransform: 'none',
                        py: 1,
                        px: 3,
                        borderRadius: 1,
                        boxShadow: 3
                    }}
                >
                    Update Role
                </Button>
            </Grid>
        </Paper>
    );
};

export default EditRoleForm;
